import React from "react";
import AnimationRevealPage from "../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import MainFeature1 from "../Components/Features/TwoColWithButton.js";
import Header from "../Components/headers/PageHeader";
import FAQ from "../Components/Faqs/SingleCol.js";
import FAQ1 from "../images/FAQ-1.avif";
import FAQ2 from "../images/FAQ-2.avif";
import FAQ3 from "../images/FAQ-3.avif";

const Subheading = tw.span`uppercase tracking-wider text-sm`;

export default ({ page }) => {
  return (
    <AnimationRevealPage>
      {page ? (
        <></>
      ) : (
        <div>
          <Header from="FAQ's" />

          <MainFeature1
            subheading={<Subheading>FAQ</Subheading>}
            heading="Frequently Asked Questions"
            buttonRounded={false}
            primaryButtonText="Contact Us"
            imageSrcs={[FAQ1, FAQ2, FAQ3]}
            description="Find answers to common questions about our web services. If you can't find what you're looking for, don't hesitate to reach out to our support team."
            widths={["70%", "70%", "70%"]}
            heights={["50%", "50%", "50%"]}
            imageColumnStyle={`height: 400px;`} // Adjusting height as required
            imageStyle={`width: 45%; height: 60%;`} // Custom styles for images
            imagePositions={[
              "left: 0%; top: 0%;",
              "right: 30%; top: 55%;",
              "left: 30%; bottom: 20%;",
            ]} // Custom positions for each image
          />
        </div>
      )}

      <FAQ
        subheading={<Subheading>FAQS</Subheading>}
        
        faqs = {[
          {
            question: "What services does MilaajBrandset offer as a website design and development company in Dubai?",
            answer:
              "As a leading <strong>website design and development company in Dubai</strong>, MilaajBrandset offers a full spectrum of digital solutions, including custom web design, professional website development, e-commerce solutions, digital marketing, API integration, and UI/UX design. Our <strong>web design services in Dubai</strong> are tailored to businesses in Downtown Dubai, Jumeirah, and across the UAE, delivering responsive, visually stunning websites that enhance your <strong>online presence</strong> and drive measurable growth."
          },
          {
            question: "How long does it take to complete a web development project with your Dubai-based company?",
            answer:
              "At MilaajBrandset, a top <strong>website design and development company in Dubai</strong>, timelines vary by project scope. A simple, responsive website typically takes 4-6 weeks, while complex <strong>e-commerce development</strong> or custom web applications may require 3-6 months. Our <strong>professional website development</strong> process includes detailed timelines and regular updates, ensuring transparency for clients across the UAE."
          },
          {
            question: "Do you provide ongoing support and maintenance for websites launched in Dubai?",
            answer:
              "Yes, as a premier <strong>website design and development company in Dubai</strong>, MilaajBrandset offers comprehensive support and maintenance packages. We ensure your website remains secure, updated, and optimized for performance, helping businesses along Sheikh Zayed Road and throughout the UAE maintain a robust <strong>online presence</strong> with our <strong>affordable web design Dubai</strong> solutions."
          },
          {
            question: "Can your Dubai web development team assist with website migrations?",
            answer:
              "Absolutely! Our experienced team at MilaajBrandset, a trusted <strong>website design and development company in Dubai</strong>, specializes in seamless website migrations. We ensure a smooth transition of content, databases, and functionality to new platforms, minimizing downtime and enhancing performance for businesses seeking <strong>top web designers in Dubai</strong>."
          },
          {
            question: "How does MilaajBrandset ensure website security for Dubai clients?",
            answer:
              "As a leading <strong>website design and development company in Dubai</strong>, MilaajBrandset prioritizes security with SSL certificates, regular audits, secure coding practices, and robust firewalls. Our <strong>professional website development</strong> approach complies with UAE digital standards, protecting your business’s online assets and ensuring trust for clients in Dubai and beyond."
          },
          {
            question: "Do you offer SEO services alongside web development in Dubai?",
            answer:
              "Yes, MilaajBrandset, a top <strong>website design and development company in Dubai</strong>, provides comprehensive <strong>digital marketing services</strong>, including SEO. Our strategies, such as on-page optimization, keyword research, and technical SEO, boost your website’s visibility and drive organic traffic, helping UAE businesses achieve higher search engine rankings."
          },
          {
            question: "Are your websites optimized for mobile users in Dubai?",
            answer:
              "Absolutely! As a leading <strong>website design and development company in Dubai</strong>, MilaajBrandset ensures all websites are fully responsive and mobile-optimized. Our <strong>responsive web design</strong> approach guarantees seamless user experiences across devices, catering to Dubai’s tech-savvy audience and enhancing your <strong>online presence solutions</strong> in the UAE market."
          },
          {
            question: "What is the cost of hiring a website design and development company in Dubai?",
            answer:
              "At MilaajBrandset, a trusted <strong>website design and development company in Dubai</strong>, costs vary based on project complexity, features, and customization. Simple websites start at affordable rates, while <strong>e-commerce development</strong> or custom solutions may require higher investment. Contact our <strong>web development agency Dubai</strong> for a tailored quote to meet your business needs."
          },
          {
            question: "What technologies does your Dubai web development team use?",
            answer:
              "MilaajBrandset, a premier <strong>website design and development company in Dubai</strong>, leverages cutting-edge technologies like React, Node.js, WordPress, and Shopify for <strong>custom web solutions</strong>. Our <strong>top web designers in Dubai</strong> select the best tools to ensure scalability, performance, and alignment with UAE business goals."
          },
          {
            question: "Can your websites scale with business growth in Dubai?",
            answer:
              "Yes, as a leading <strong>website design and development company in Dubai</strong>, MilaajBrandset builds scalable websites that grow with your business. Our <strong>professional website development</strong> process incorporates flexible architectures and modular designs, ensuring your site supports increased traffic and functionality for businesses across the UAE."
          }
        ]}
      />
    </AnimationRevealPage>
  );
};
